// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useEffect, useState } from "react"
import { useLocales } from "react-localized"
import {
  IonButton, IonCol, IonContent, IonGrid, IonModal,
  IonRow, IonText
} from "@ionic/react"
import AnonymousUser from "./AnonymousUser"
import IUser from "./IUser"
import CancelButton from './CancelButton'
import { client } from './GatewayClient'
import useSession from "./useSession"
import './CurrentUserMenu.scss'


interface CurrentUserMenuProps {
  user: IUser
}


const CurrentUserMenu: React.FC<CurrentUserMenuProps> = ({
  user
}) => {
  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));
  const {booting, setBooting, setUser} = useSession()
  const [showModal, setShowModal] = useState<boolean>(false)
  const {gettext, locale} = useLocales()

  useEffect(() => {
    if (!!booting) { setShowModal(false) }
  }, [booting])

  if (!user.isAuthenticated()) { return null }
  return (
    <>
      <IonButton onClick={() => setShowModal(true)}>
        <span className="avatar-character">{user.getDisplayName()}</span>
      </IonButton>
      <IonModal
        className="user-menu"
        breakpoints={[1.0]}
        initialBreakpoint={1.0}
        isOpen={showModal}
        onDidDismiss={() => setShowModal(false)}
      >
        <IonContent scrollY={false}>
          <IonGrid>
            <IonRow className="main">
              <IonText>
                <strong>
                  {user.getGivenName()} {user.getFamilyName()}<br/>
                </strong>
                <span className="color-medium">{user.getEmail()}</span>
              </IonText>
            </IonRow>
            <IonRow>
              <IonCol size="12">
                <IonButton
                  fill="clear"
                  onClick={async () => {
                    setBooting(true)
                    window.location.href = await client.login(locale, window.location.href, {prompt: "select_account"})
                    await sleep(2500)
                  }}
                  style={{height: "44px", marginBottom: "11px", width: "100%"}}
                >
                  {gettext("Use a different email address")}
                </IonButton>
                <CancelButton
                  onClick={() => {
                    setShowModal(false)
                    setBooting(true)
                    user.signout()
                      .then(() => {
                        setTimeout(() => {
                          setUser(new AnonymousUser())
                          setBooting(false)
                        }, 1500)
                      })
                  }}
                  title={gettext("Sign out")}
                />
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonModal>
    </>
  )
}


export default CurrentUserMenu